"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _saleBookings = _interopRequireDefault(require("./sale-bookings.store"));
var _retrieveSale = _interopRequireDefault(require("./retrieve-sale.store"));
var _user = _interopRequireDefault(require("./user.store"));
//
/**
 * sale bookings page store
 */
//
let SaleBookingsPageStore = /*#__PURE__*/(0, _createClass2.default)(
/**
 * constructor
 * @param {Object} initialState
 * @param {Object} $env
 */
function SaleBookingsPageStore(initialState = {}, $env) {
  (0, _classCallCheck2.default)(this, SaleBookingsPageStore);
  this.$env = $env;
  this.salebookingsStore = new _saleBookings.default(initialState.salebookingsStore, this.$env);
  this.userStore = new _user.default(initialState.userStore);
  this.retrieveSaleStore = new _retrieveSale.default(initialState.retrieveSaleStore, this.$env);
});
exports.default = SaleBookingsPageStore;